import './Footer.css';

function Footer() {
    return (
        <>
            <div className="Footer">
                <p>Made at <a href="https://sepcode.eu/">SEP Technologies Inc.</a>, 2026</p>
            </div>
        </>
    );
}

export default Footer;